import { useEffect } from 'react'
// import { redirect } from 'react-router-dom'

const Redirect = ({ to }) => {
  // console.log(to)

  useEffect(() => {
    // console.log('redirecting')
    // Redirect to the given URL.
    window.location.href = to
  }, [to])

  return null
}

export default Redirect
